<template>
  <frontoffice-frame :padding-content="false">
    <frontoffice-loader v-if="isLoading" class="loader-section container" />

    <div v-else class="row justify-content-center">
      <div id="page" class="booking-group-prelogged col-12 col-md-8">
        <div v-if="logo" class="row justify-content-center">
          <div class="companyPrelogged-logo text-center col-5">
            <img :src="logo" alt="logo" class="logo" />
          </div>
        </div>

        <h2 v-else class="companyPrelogged-name">{{ name }}</h2>

        <p class="companyPrelogged-message">{{ label }}</p>

        <ul class="companyPrelogged-links row justify-content-around">
          <router-link v-for="company in companies" :key="company.id"
                       :to="{
                         name: 'offline_booking_prelogged_company',
                         params: {
                           companyUid: uid,
                           values: company.values
                         }
                       }"
                       tag="a" class="btn orange-white col-8"
          >
            <li>{{ company.name }}</li>
          </router-link>
        </ul>
      </div>
    </div>
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    frontofficeFrame,
    frontofficeLoader
  },

  data () {
    return {
      commonApi: new CommonApi(),
      isLoading: true,
      alias: this.$route.params.groupAlias,
      group: null
    }
  },

  created () {
    this.commonApi.getCompanyGroupData(this.alias)
      .then(response => {
        if (response.data.success) {
          this.isLoading = false
          this.group = response.data.data
        }
      })
  },

  computed: {
    logo () {
      return this.group.company.logo_image
    },

    name () {
      return this.group.company.name
    },

    uid () {
      return this.group.company.random_unique_chain
    },

    label () {
      return this.group.text
    },

    companies () {
      let ret = []

      for (let [companyName, inputFields] of Object.entries(this.group.data)) {
        let values = []

        for (let [inputFieldId, value] of Object.entries(inputFields)) {
          values.push(`${inputFieldId}-${value}`)
        }

        ret.push({
          name: companyName,
          values: values.join('_')
        })
      }

      return ret
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/booking_unlogged.scss';
</style>
